import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _slicedToArray from "@babel/runtime-corejs3/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/esm/toConsumableArray";
var _excluded = ["children"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import React, { Component } from 'react';
import throttle from 'just-throttle';
import { ResizeObserver as ResizeObserver$1 } from '@juggle/resize-observer';
var ResizeObserver = typeof window !== 'undefined' && window.ResizeObserver || ResizeObserver$1;

function lastVisibleIndex(lens, maxLen, gap) {
  var extra = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var currentLen = 0;

  for (var i = 0; i < lens.length; ++i) {
    var gapIfNeeded = i === 0 ? 0 : gap;

    if (currentLen + lens[i] + gapIfNeeded > maxLen - extra) {
      return [i - 1, maxLen - currentLen];
    }

    currentLen += lens[i] + gapIfNeeded;
  }

  return [lens.length - 1, maxLen - currentLen];
}

function measureElement(element) {
  return {
    width: element.offsetWidth,
    height: element.offsetHeight
  };
} // Flattens all child elements into a single list


var flatten = function flatten(children) {
  var _context;

  var flat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var newFlat = _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(flat), _toConsumableArray(React.Children.toArray(children)));

  if (children.props && children.props.children) {
    return flatten(children.props.children, newFlat);
  }

  return newFlat;
}; // Strips all circular references and internal fields


var simplify = function simplify(children) {
  var flat = flatten(children);
  return _mapInstanceProperty(flat).call(flat, function (_ref) {
    var key = _ref.key,
        type = _ref.type,
        _ref$props = _ref.props,
        flattenChildren = _ref$props.children,
        props = _objectWithoutProperties(_ref$props, _excluded);

    return {
      key: key,
      type: type,
      props: props
    };
  });
};

var Foldable = /*#__PURE__*/function (_Component) {
  _inherits(Foldable, _Component);

  var _super = _createSuper(Foldable);

  // eslint-disable-next-line react/sort-comp
  function Foldable(props) {
    var _this;

    _classCallCheck(this, Foldable);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "containerRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "plusNRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "childrenEls", void 0);

    _defineProperty(_assertThisInitialized(_this), "childrenWidths", void 0);

    _defineProperty(_assertThisInitialized(_this), "resizeObserver", void 0);

    _defineProperty(_assertThisInitialized(_this), "tagsResizeObserver", void 0);

    _defineProperty(_assertThisInitialized(_this), "measureChildren", function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
          childrenEls = _assertThisInitialize.childrenEls;

      if (childrenEls.some(function (r) {
        return r === null;
      })) {
        throw new Error('childrenEls should be all not nulls');
      }

      _this.childrenWidths = _mapInstanceProperty(childrenEls).call(childrenEls, function (r) {
        return measureElement(r).width;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "recalculateLastVisibleAndSetStage", function () {
      var nextStage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _assertThisInitialize2 = _assertThisInitialized(_this),
          containerRef = _assertThisInitialize2.containerRef,
          plusNRef = _assertThisInitialize2.plusNRef;

      if (!containerRef.current) {
        throw new Error('containerRef should be not null during recalculate');
      }

      var containerWidth = measureElement(containerRef.current).width;
      var plusNWidth = 0;

      if (plusNRef.current) {
        plusNWidth = measureElement(plusNRef.current).width;
      }

      var gap = _this.props.gap || 0;

      var _lastVisibleIndex = lastVisibleIndex(_this.childrenWidths, containerWidth, gap, plusNWidth + gap + 1),
          _lastVisibleIndex2 = _slicedToArray(_lastVisibleIndex, 2),
          index = _lastVisibleIndex2[0],
          extra = _lastVisibleIndex2[1];

      var children = React.Children.toArray(_this.props.children);
      var showLastChildIfFit = index === children.length - 2 && extra - gap - 1 > _this.childrenWidths[_this.childrenWidths.length - 1];
      var newLastVisible = index + (showLastChildIfFit ? 1 : 0);
      var newState = {
        lastVisible: newLastVisible,
        renderingStage: nextStage ? nextStage : _this.state.renderingStage
      };

      _this.setState(newState);
    });

    _this.state = {
      lastVisible: props.children.length - 1,
      renderingStage: 0,
      prevChildren: props.children
    };
    _this.containerRef = /*#__PURE__*/React.createRef();
    _this.plusNRef = /*#__PURE__*/React.createRef();
    _this.childrenEls = [];
    _this.childrenWidths = [];
    return _this;
  }

  _createClass(Foldable, [{
    key: "observeChildren",
    value: function observeChildren() {
      var _this2 = this;

      var isInitialized = false;

      var onTagsSizeChangedThrottled = function onTagsSizeChangedThrottled() {
        if (isInitialized && // skip updating if the container is not displayed on the page
        _this2.containerRef.current.offsetParent !== null) {
          _this2.setState({
            renderingStage: 0
          });
        } else {
          isInitialized = true;
        }
      };

      if (this.tagsResizeObserver) {
        this.tagsResizeObserver.disconnect();
      }

      this.tagsResizeObserver = new ResizeObserver(onTagsSizeChangedThrottled);
      this.childrenEls.forEach(function (child) {
        return _this2.tagsResizeObserver.observe(child);
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      var renderingStage = this.state.renderingStage;

      if (renderingStage === 0) {
        this.measureChildren();
        this.observeChildren();
        this.recalculateLastVisibleAndSetStage(1);
      }

      var onSizeChangedThrottled = throttle(function () {
        if (_this3.state.renderingStage === 2) {
          _this3.recalculateLastVisibleAndSetStage();
        }
      }, 50);
      this.resizeObserver = new ResizeObserver(onSizeChangedThrottled);
      this.resizeObserver.observe(this.containerRef.current);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var renderingStage = this.state.renderingStage;

      if (renderingStage === 0) {
        this.measureChildren();
        this.observeChildren();
        this.recalculateLastVisibleAndSetStage(1);
      } else if (renderingStage === 1) {
        this.recalculateLastVisibleAndSetStage(2);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

      if (this.tagsResizeObserver) {
        this.tagsResizeObserver.disconnect();
      }
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(lastVisible) {
      var _context2,
          _this4 = this;

      var children = React.Children.toArray(this.props.children);
      return _mapInstanceProperty(_context2 = _sliceInstanceProperty(children).call(children, 0, lastVisible + 1)).call(_context2, function (child, i) {
        return /*#__PURE__*/React.cloneElement(child, {
          ref: function ref(el) {
            if (el) {
              _this4.childrenEls[i] = el;
            }
          }
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var renderHiddenCounter = this.props.renderHiddenCounter;
      var children = React.Children.toArray(this.props.children);
      var lastVisible = this.state.renderingStage === 0 ? children.length - 1 : this.state.lastVisible;

      if (children.length !== this.childrenEls.length) {
        var _context3;

        this.childrenEls = _sliceInstanceProperty(_context3 = this.childrenEls).call(_context3, 0, children.length);
      }

      return /*#__PURE__*/React.createElement("div", {
        className: this.props.className,
        ref: this.containerRef
      }, this.renderChildren(lastVisible), lastVisible !== children.length - 1 ? renderHiddenCounter(children.length - lastVisible - 1, this.plusNRef) : null);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (_JSON$stringify(simplify(props.children)) !== _JSON$stringify(simplify(state.prevChildren))) {
        return {
          prevChildren: props.children,
          renderingStage: 0
        };
      }

      return null;
    }
  }]);

  return Foldable;
}(Component);

export { Foldable as default };
